<template>
  <dialog-view :open="open" title="Другие чаты пациента" big contentFullSize @cancel="$emit('cancel')">
    <template v-slot:content>
      <div class="pa-3">
        <v-select v-if="clients.length>1" v-model="dialogUserId" :items="clientOptions"
                  label="Пациент" outlined dense hide-details class="mb-3"/>
        <v-progress-linear v-if="loading" indeterminate/>
        <v-alert v-if="error" type="error" dense text>{{ error }}</v-alert>
        <div v-else-if="!loading && chats.length===0" class="pa-4 text-center muted1">Другие чаты не найдены</div>
        <v-row v-else no-gutters>
          <v-col cols="12" md="4" class="overflow-y-auto" style="max-height: 65vh">
            <v-list dense class="pa-0">
              <v-list-item v-for="item in chats" :key="item.id" :input-value="selectedChat?.id===item.id"
                           @click="selectChat(item)">
                <v-list-item-content>
                  <v-list-item-title>{{ item.name || item._name }} · #{{ item.id }}</v-list-item-title>
                  <v-list-item-subtitle>{{ providers(item) }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{ $tools.dateFormat(item.dialogMesLast?.created || item.created) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col cols="12" md="8" class="overflow-y-auto" style="height: 65vh">
            <v-progress-linear v-if="messagesLoading" indeterminate/>
            <v-alert v-if="messagesError" type="error" dense text class="ma-3">{{ messagesError }}</v-alert>
            <div v-else-if="!selectedChat" class="pa-4 text-center muted1">Выберите чат для просмотра переписки</div>
            <template v-else>
              <div class="pa-3 caption muted1">{{ selectedChat.name || selectedChat._name }} · #{{ selectedChat.id }} · Последние 100 записей</div>
              <div v-if="!messagesLoading && messages.length===0" class="pa-4 text-center muted1">Сообщений нет</div>
              <dialog-page-message v-for="message in messages" :key="selectedChat.id+'-'+message.id"
                                   :message="message" :cat="selectedChat.cat" read-only/>
            </template>
          </v-col>
        </v-row>
      </div>
    </template>
  </dialog-view>
</template>

<script>
import axios from 'axios';
import DialogView from '@/components/DialogView.vue';
import DialogPageMessage from './DialogPageMessage.vue';

export default {
  components: {DialogView, DialogPageMessage},
  props: ['open', 'chat', 'clients'],
  data: () => ({
    dialogUserId: null, chats: [], selectedChat: null, messages: [],
    loading: false, messagesLoading: false, error: null, messagesError: null,
    listRequestId: 0, messagesRequestId: 0,
  }),
  computed: {
    clientOptions() {
      return this.clients.map(v => ({value: v.id, text: (v.user ? this.$tools.userFullName(v.user) : v.name) + (v.phone ? ' · ' + v.phone : '')}));
    },
  },
  watch: {
    open(v) {
      this.listRequestId++;
      this.messagesRequestId++;
      this.chats = [];
      this.selectedChat = null;
      this.messages = [];
      if (!v) return;
      const clientId = this.clients[0]?.id ?? null;
      if (this.dialogUserId === clientId) this.loadChats();
      else this.dialogUserId = clientId;
    },
    dialogUserId() {
      if (this.open) this.loadChats();
    },
    'chat.id'() {
      this.listRequestId++;
      this.messagesRequestId++;
      this.$emit('cancel');
    },
  },
  beforeDestroy() {
    this.listRequestId++;
    this.messagesRequestId++;
  },
  methods: {
    providers(chat) {
      return [...new Set((chat.dialogUsers || []).filter(v => v.provider !== 'internal').map(v => this.$tools.dialogProviderName(v.provider)))].join(', ');
    },
    loadChats() {
      const requestId = ++this.listRequestId;
      this.messagesRequestId++;
      this.chats = [];
      this.selectedChat = null;
      this.messages = [];
      this.error = null;
      this.messagesError = null;
      this.messagesLoading = false;
      this.loading = this.dialogUserId != null;
      if (this.dialogUserId == null) return;
      axios.get('/napi/dialog/chat/' + this.chat.id + '/related/', {params: {dialogUserId: this.dialogUserId}})
          .then(r => { if (this.open && requestId === this.listRequestId) this.chats = r.data; })
          .catch(() => { if (requestId === this.listRequestId) this.error = 'Не удалось загрузить другие чаты'; })
          .finally(() => { if (requestId === this.listRequestId) this.loading = false; });
    },
    selectChat(chat) {
      const requestId = ++this.messagesRequestId;
      this.selectedChat = chat;
      this.messages = [];
      this.messagesError = null;
      this.messagesLoading = true;
      axios.get('/napi/dialog/chat/' + chat.id + '/message/')
          .then(r => {
            if (!this.open || requestId !== this.messagesRequestId || this.selectedChat?.id !== chat.id) return;
            this.messages = (r.data || []).filter(v => v.dialogChat?.id == null || String(v.dialogChat.id) === String(chat.id))
                .slice().sort((a, b) => Number(a.id) - Number(b.id));
          })
          .catch(() => { if (requestId === this.messagesRequestId) this.messagesError = 'Не удалось загрузить переписку'; })
          .finally(() => { if (requestId === this.messagesRequestId) this.messagesLoading = false; });
    },
  },
};
</script>
